export default class MidlistYandex extends React.Component {
  componentDidMount () {
    (function (w, d, n, s, t) {
      if (typeof w !== 'undefined') {
        w[n] = w[n] || [];
        w[n].push(function () {
          Ya.Context.AdvManager.render({
            blockId: "R-A-137031-5",
            renderTo: "yandex_rtb_R-A-137031-5",
            async: true
          });
        });
        // загрузка скрипта, если он ещё не загружен
        if ($('script[src$="//an.yandex.ru/system/context.js"]').length === 0) {
          t = d.getElementsByTagName("script")[0];
          s = d.createElement("script");
          s.type = "text/javascript";
          s.src = "//an.yandex.ru/system/context.js";
          s.async = true;
          t.parentNode.insertBefore(s, t);
        }
      }
    })(window, document, "yandexContextAsyncCallbacks");
  }

  shouldComponentUpdate (nextProps) {
    return nextProps.number_of_camps !== this.props.number_of_camps;
  }

  render () {
    if (this.props.show_ads && this.props.number_of_camps >= this.props.camps_required) {
      return (
        <div className="card card_big card_ads justify-content-center"
             id="yandex_rtb_R-A-137031-5"
        />
      );
    }
    return (
      <div/>
    )
  }
}
